import Vue from "vue";
import {axiosGet} from "./AxiosHelper";
import {GET_STATUSES} from "../Config/ApiUrl";

export const createdFilter = () => ({
    title: Vue.prototype.$t('created'),
    type: "range-picker",
    key: "date",
    option: ["today", "thisMonth", "last7Days", "thisYear"]
});

export const statusesFilter = async (type) => {
    const { data } = await axiosGet(`/${GET_STATUSES}?type=${type}`);
    return {
        title: Vue.prototype.$t('status'),
        type: "drop-down-filter",
        key: "status_id",
        option: data,
        listValueField: 'translated_name'
    }
};